<template>
  <popup
    class="rb-popup-gia"
    title="GIA Certificate"
    :active="active"
    :on-screen="onScreen"
    @close="close"
  >
    <div class="rb-center">
      <p>
        All of our
        <strong>sample videos closely match the diamond it represents</strong>
        in color, shape, size, and scale. Each diamond comes with a unique GIA
        Certificate.
      </p>
      <p>
        All of our diamonds are
        <strong>carefully curated within strict aesthetic parameters</strong> to
        ensure that our stones have identical shapes and facets from one diamond
        to the next.
      </p>
    </div>
  </popup>
</template>

<script>
/**
 * Popup with GIA information
 *
 * @implements
 * PopupMixin
 */
import Popup from "@/components/Popup";
import PopupMixin from "@/mixins/PopupMixin";
export default {
  components: {
    Popup,
  },
  mixins: [PopupMixin],
};
</script>
